@if ((loading$ | async) === false) {
  <crm-newsletter-template-form
    [data]="template"
    [canDelete]="(form$ | async)?.isEdit"
    [canWrite]="(form$ | async)?.canWrite"
    [isModal]="true"
    [emails]="emails"
    [arraySms]="arraySms"
    [externalUsers]="externalUsers"
    [recipientUsers]="recipientUsers"
    [directions]="directions"
    (save)="saveNewsletterTemplate($event)"
    (delete)="deleteNewsletterTemplate()"></crm-newsletter-template-form>
}

@if (loading$ | async) {
  <crm-spinner></crm-spinner>
}
